module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/students.json
// module id = 444
// module chunks = 126276644007512